import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import './textField.css';

const TextField = React.forwardRef(function TextField(props, ref) {
  const {
    className,
    variant = 'default',
    type = 'text',
    as: Component = 'input',
    disabled = false,
    error,
    rows,
    onlyNumbers,
    value,
    onChange,
    ...rest
  } = props;

  const [isValid, setIsValid] = useState(false);

  const debouncedCheck = useCallback(() => {
    if (value && value.length > 3) {
      setIsValid(true);
    } else {
      setIsValid(false);
    }
  }, [value]);

  useEffect(() => {
    const timer = setTimeout(() => {
      debouncedCheck();
    }, 2000);

    return () => clearTimeout(timer);
  }, [value, debouncedCheck]);

  let autoCompleteValue;
  if (type === 'tel') {
    autoCompleteValue = 'tel';
  } else if (type === 'email') {
    autoCompleteValue = 'email';
  } else if (type === 'password') {
    autoCompleteValue = 'new-password';
  } else {
    autoCompleteValue = 'off';
  }
  const textFieldClass = `textfield ${className || ''} 
                          ${variant === 'outlined' ? 'outlined' : ''} 
                          ${variant === 'filled' ? 'filled' : ''} 
                          ${variant === 'standard' ? 'standard' : ''} 
                          ${variant === 'password' ? 'password' : ''} 
                          ${variant === 'email' ? 'email' : ''}
                          ${disabled ? 'disabled' : ''}
                          ${error ? 'error' : ''}
                          ${onlyNumbers ? 'only-numbers' : ''}
                          ${isValid ? 'valid' : ''}`;

  const handleKeyDown = (e) => {
    if (onlyNumbers) {
      if ([46, 8, 9, 27, 13, 110, 190].indexOf(e.keyCode) !== -1 ||
        (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) || 
        (e.keyCode >= 35 && e.keyCode <= 40)) {
        return;
      }
      if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
        e.preventDefault();
      }
    }
  };

  const handleChange = (e) => {
    if (props.onChange) {
      props.onChange(e);
    }
  };

  return (
    <div className="textfield-wrapper">
      <Component
        ref={ref}
        className={textFieldClass}
        type={Component === 'input' ? (onlyNumbers ? 'tel' : type) : undefined}
        disabled={Component === 'input' ? disabled : undefined}
        rows={Component === 'textarea' ? rows : undefined}
        onKeyDown={handleKeyDown}
        onChange={handleChange}
        autoComplete={autoCompleteValue}
        {...rest}
      />
      {error && <div className="error-message">{error}</div>}
    </div>
  );
});

TextField.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.oneOf(['default', 'outlined', 'filled', 'standard', 'password', 'email']),
  type: PropTypes.string,
  as: PropTypes.elementType,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  rows: PropTypes.number,
  onlyNumbers: PropTypes.bool,
  onChange: PropTypes.func,
};

export default TextField;
